/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IoChevronBackOutline } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import validator from 'validator';
import { Get } from '../../../Axios/AxiosFunctions';
import Button from '../../../Component/Button/Button';
import CustomFileInput from '../../../Component/CustomFileInput';
import DropDown from '../../../Component/DropDown/DropDown';
import FileUpload from '../../../Component/FileUpload';
import FormLanguages from '../../../Component/FormLanguages';
import Input from '../../../Component/Input/Input';
import { Loader } from '../../../Component/Loader';
import LocationComponent from '../../../Component/LocationComponent';
import LottieLoader from '../../../Component/LottieLoader/LottieLoader';
import SideBarSkeleton from '../../../Component/SideBarSkeleton';
import TextArea from '../../../Component/TextArea';
import UploadImageBox from '../../../Component/UploadImageBox';
import { BaseURL, CreateFormData, formatLabel } from '../../../config/apiUrl';
import { languagesKeysObject, languagesOptions } from '../../../constant/commonData';
import {
  useAddOrEditProjectMutation,
  useDeletePropertyMediaMutation,
  useGetSingleProjectQuery
} from '../../../store/apiSlice/apiSlice';
import { uploadImagesHelper } from '../../../utils/helpers';
import classes from './NewProject.module.css';
import { Divider } from '@mui/material';
import QuillInput from '../../../Component/QuillInput';
import { MdAutoAwesome } from 'react-icons/md';

function NewProject() {
  const navigate = useNavigate();
  const slug = useParams()?.slug;
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const [language, setLanguage] = useState(
    languagesOptions?.find((item) => item?.value === selectedLanguage)
  );

  const { t } = useTranslation(['dashboardProjects', 'locationComp'], {
    lng: language?.value
  });
  const { t: languageD } = useTranslation('locationComp', { lng: language?.value });

  // new image states
  const [isUploadingImages, setIsUploadingImages] = useState(false);

  // Language
  const [formStates, setFormStates] = useState({
    name: languagesKeysObject,
    title: languagesKeysObject,
    description: languagesKeysObject,
    developerName: languagesKeysObject,
    // registrationNumber: null,
    projectType: '',
    // minimumSellingPrice: '',
    // maximumSellingPrice: '',
    price: '',
    noOfUnits: '',
    minimumArea: '',
    maximumArea: '',
    // deliveryDate: '',
    status: '',
    exteriorAmenities: [],
    interiorAmenities: []
  });

  const [locationState, setLocationState] = useState({
    province: null,
    town: null,
    neighbourhood: null,
    address: '',
    lat: 39.9334,
    lng: 32.8597
  });

  //  media
  const [projectLogo, setProjectLogo] = useState(null);
  const [images, setImages] = useState([]);
  const [planImages, setPlanImages] = useState([]);
  const [videoLink, setVideoLink] = useState('');
  const [View360, setView360] = useState('');
  const [view360DragDrop, setView360DragDrop] = useState(null);
  const [catalogue, setCatalogue] = useState(null);
  const [uploadedImages, setUploadedImages] = useState([]);
  const [uploadedPlanImages, setUploadedPlanImages] = useState([]);

  const { projectTypes, interiorAmenities, exteriorAmenities, projectStatus } = useSelector(
    (state) => state?.commonReducer
  );
  const [creatOrEditProjectFn, { isLoading: apiSubmitingLoading }] = useAddOrEditProjectMutation();
  const [deletePropertyMedia, { isLoading: isDeletingMedia }] = useDeletePropertyMediaMutation();

  const { data: projectData, isLoading: isGetting } = useGetSingleProjectQuery(
    {
      slug: slug
    },
    {
      skip: !slug
    }
  );

  const deleteMedia = async (e) => {
    const res = await deletePropertyMedia(e);
    if (res?.data) {
      if (e?.type == 'images') {
        setUploadedImages((prev) => prev.filter((a) => a !== e?.key));
      } else {
        setUploadedPlanImages((prev) => prev.filter((a) => a !== e?.key));
      }
      toast.success(t('toast.mediaUpdatedSuccessfully'));
    }
  };

  const accessToken = useSelector((state) => state?.authReducer?.accessToken);
  // check if eligible for adding new property
  useEffect(() => {
    if (!slug) {
      const handleEligibility = async () => {
        const url = BaseURL(`users/check-limit?type=project`);
        const res = await Get(url, accessToken);
        if (res) {
          if (res?.data?.data === false) {
            toast.error(
              'You have reached the limit of adding new projects, please upgrade your plan'
            );
            navigate(-1);
          }
        }
      };

      handleEligibility();
    }
  }, []);

  // validateParams
  const validateParams = () => {
    const multiLanguageParams = {
      name: formStates?.name,
      title: formStates?.title,
      description: formStates?.description,
      developerName: formStates?.developerName
    };
    let params = {
      projectType: formStates?.projectType?._id,
      price: formStates?.price,
      noOfUnits: formStates?.noOfUnits,
      minimumArea: formStates?.minimumArea,
      maximumArea: formStates?.maximumArea,
      // deliveryDate: formStates?.deliveryDate,
      status: formStates?.status?._id,
      exteriorAmenities: formStates?.exteriorAmenities?.map((item) => item?._id),
      interiorAmenities: formStates?.interiorAmenities?.map((item) => item?._id),

      logo: projectLogo,
      lng: locationState?.lng,
      lat: locationState?.lat,
      address: locationState?.address,
      province: locationState?.province?._id,
      town: locationState?.town?._id,
      neighborhood: locationState?.neighbourhood?._id,
      videoLink,
      // threeSixtyViewLink: View360 || view360DragDrop,
      threeSixtyViewLink: View360,
      pdf: catalogue
    };

    // validation on plan and images length must be 3 or greater than 3
    if (uploadedImages?.length + params?.images?.length < 3) {
      toast.error(t('toast.uploadImage'));
      return [false, null];
    }

    if (uploadedPlanImages?.length + params?.planImages?.length < 3) {
      toast.error(t('toast.threePlanImages'));
      return [false, null];
    }

    for (let lang in languagesKeysObject) {
      const langLabel_ = languagesOptions.find((item) => item?.value === lang)?.label;
      // validate multiLanguageParams
      for (let key in multiLanguageParams) {
        if (!multiLanguageParams[key][lang]) {
          if (key === 'name') key = 'projectName';
          if (key === 'title') key = 'projectTagline';
          if (key === 'description') key = 'projectDescription';

          toast.error(
            `${t('toast.pleaseFillThe')} ${formatLabel(key)} ${t(
              'toast.inLanguage'
            )} "${langLabel_}".`
          );
          return [false, null];
        }
      }

      // validate params
      for (let key in params) {
        // skip the following keys
        if (['threeSixtyViewLink', 'videoLink', 'pdf', 'logo'].includes(key)) {
          continue;
        }

        if (!params[key]) {
          toast.error(`${t('toast.pleaseFillThe')} ${formatLabel(key)} ${t('toast.field')}.`);
          return [false, null];
        }
        if (Array.isArray(params[key]) && params[key].length === 0) {
          toast.error(`${t('toast.add/select')} ${formatLabel(key)}.`);
          return [false, null];
        }
        // if key is a url
        if (key.includes('Link') || key.includes('link')) {
          if (typeof params[key] == 'object') {
            // return [true, { ...params, ...multiLanguageParams }];
            continue;
          }
          // if key is a url
          if (['videoLink'].includes(key)) {
            if (!validator.isURL(params[key])) {
              toast.error(`${t('toast.validKey')} ${formatLabel(key)}.`);
              return [false, null];
            }
          }

          // threeSixtyViewLink must be a valid url
          if (params?.threeSixtyViewLink && !validator.isURL(params?.threeSixtyViewLink)) {
            toast.error(t('toast.validKey', { field: 'View360' }) + ' 360 View Link');
            return [false, null];
          }
        }
      }
    }

    // if (!params?.pdf) {
    //   toast.error(t('toast.projectPdfCatalogueError'));
    //   return [false, null];
    // }
    params = {
      ...params,
      // images,
      // planImages
      images: uploadedImages,
      planImages: uploadedPlanImages
    };
    if (Number(formStates?.maximumArea) < Number(formStates?.minimumArea)) {
      toast.error(t('toast.maxArea'));
      return [false, null];
    }

    return [true, { ...params, ...multiLanguageParams }];
  };

  // handleSubmit
  const handleSubmit = async () => {
    const [isValid, params] = validateParams();

    if (!isValid) return;
    const formData = await CreateFormData(params);

    // api
    const response = await creatOrEditProjectFn({ data: formData, ...(slug && { slug }) });
    if (response.data) {
      toast.success(
        `${t('toast.project')} ${slug ? t('toast.updated') : t('toast.added')} ${t(
          'toast.successfully'
        )}`
      );
      navigate(-1);
    }
  };

  useEffect(() => {
    if (projectData?.data) {
      setFormStates({
        name: projectData?.data?.name,
        title: projectData?.data?.title,
        description: projectData?.data?.description,
        developerName: projectData?.data?.developerName,
        projectType: projectData?.data?.projectType,
        price: projectData?.data?.price,
        noOfUnits: projectData?.data?.noOfUnits,
        minimumArea: projectData?.data?.minimumArea,
        maximumArea: projectData?.data?.maximumArea,
        // deliveryDate: projectData?.data?.deliveryDate,
        status: projectData?.data?.status,
        exteriorAmenities: projectData?.data?.exteriorAmenities,
        interiorAmenities: projectData?.data?.interiorAmenities
        // registrationNumber: projectData?.data?.registrationNumber
      });
      setLocationState({
        province: projectData?.data?.province,
        town: projectData?.data?.town,
        neighbourhood: projectData?.data?.neighborhood,
        address: projectData?.data?.address,
        lat:
          projectData?.data?.location?.coordinates?.length > 0
            ? projectData?.data?.location?.coordinates[1]
            : '',
        lng:
          projectData?.data?.location?.coordinates?.length > 0
            ? projectData?.data?.location?.coordinates[0]
            : ''
      });
      setProjectLogo(projectData?.data?.logo);
      // setImages(projectData?.data?.images);
      // setPlanImages(projectData?.data?.planImages);
      setVideoLink(projectData?.data?.videoLink);
      setView360(projectData?.data?.threeSixtyViewLink);
      setCatalogue(projectData?.data?.projectBrochure);
      // only Show States

      setUploadedImages(projectData?.data?.images);
      setUploadedPlanImages(projectData?.data?.planImages);
    }
  }, [isGetting]);

  const [autoFillLoading, setAutoFillLoading] = useState(false);
  const handleAutoFill = async () => {
    setAutoFillLoading(true);
    const multiLanguageFields = {
      eventName: formStates?.name,
      title: formStates?.title,
      description: formStates?.description,
      developerName: formStates?.developerName
    };

    const currentLang = language?.value;
    const langLabel = languagesOptions?.find((e) => e?.value === currentLang)?.label ?? 'Unknown';

    // Check if all required fields have content in current language
    for (const key in multiLanguageFields) {
      const value = multiLanguageFields[key]?.[currentLang]?.trim();
      const label = formatLabel(key);
      if (!value) {
        toast.error(
          `Missing field "${
            label === 'Event Name' ? 'Name' : label === 'Title' ? 'Tag line' : label
          }" in ${langLabel}`
        );
        return;
      }
    }

    const fallbackData = {
      eventName: {
        en: 'new project',
        tr: 'yeni proje',
        ru: 'новый проект',
        de: 'neues projekt',
        fr: 'nouveau projet',
        ar: 'مشروع جديد',
        fa: 'پروژه جدید'
      },
      title: {
        en: 'project tagline',
        tr: 'proje sloganı',
        ru: 'слоган проекта',
        de: 'projekt-slogan',
        fr: 'slogan du projet',
        ar: 'شعار المشروع',
        fa: 'شعار پروژه'
      },
      description: {
        en: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Projectdkhdudjfjdkfj Description</span></p>',
        tr: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Proje Açıklaması</span></p>',
        ru: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Описание проекта</span></p>',
        de: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Projektbeschreibung</span></p>',
        fr: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">Description du projet</span></p>',
        ar: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">وصف المشروع</span></p>',
        fa: '<p><span style="background-color: rgb(255, 255, 255); color: rgb(2, 154, 138);">توضیحات پروژه</span></p>'
      },
      developerName: {
        en: 'Developer Name',
        tr: 'Geliştirici Adı',
        ru: 'Имя разработчика',
        de: 'Name des Entwicklers',
        fr: 'Nom du développeur',
        ar: 'اسم المطور',
        fa: 'نام توسعه دهنده'
      }
    };

    // Show loading toast
    const loadingToast = toast.loading('Translating fields to other languages...');

    try {
      const response = await fetch(
        'https://turegu-ai-api.devcustomprojects.online/translate/property',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            ...multiLanguageFields
          }),
          redirect: 'follow'
        }
      );
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setFormStates({
        ...formStates,
        name: { ...data?.eventName },
        title: { ...data?.title },
        description: { ...data?.description },
        developerName: { ...data?.developerName }
      });
    } catch (error) {
      // setFormStates({
      //   ...formStates,
      //   name: { ...fallbackData.eventName },
      //   title: { ...fallbackData.title },
      //   description: { ...fallbackData.description },
      //   developerName: { ...fallbackData.developerName }
      // });
    } finally {
      toast.dismiss(loadingToast);
      setAutoFillLoading(false);
    }
  };

  return (
    <>
      <style>
        {`
        @media (max-width: 768px) {
        .container{
        max-width: 100% !important;
        }
        .LocationComponent_row_main__ZtY4U{
        row-gap: 25px !important;
        }
        }
        @media (max-width: 420px) {
        .LocationComponent_row_main__ZtY4U{
        row-gap: 15px !important;
        }
        .button_btn__vXed8{
        padding-inline: 10px !important;}
        }
        `}
      </style>
      <SideBarSkeleton>
        {isGetting ? (
          <Loader className={classes?.loader} />
        ) : (
          <Container fluid className={classes.page}>
            <Row>
              <Col md={12} className={classes.mb30}>
                <Button
                  leftIcon={<IoChevronBackOutline />}
                  variant=""
                  className={classes.backBtn}
                  onClick={() => {
                    navigate('/agent/projects-management');
                  }}>
                  {t('form.goBack')}
                </Button>
              </Col>
              <Col md={12}>
                <div
                  className={[
                    classes.formBg,
                    ['ar', 'fa']?.includes(language?.value) ? 'rtl' : 'ltr'
                  ].join(' ')}>
                  <Container>
                    <Row className={classes.formRow}>
                      <Col md={12} className="d-flex justify-content-between align-items-center">
                        <h3 className={classes.title}>
                          {slug ? t('form.titleEdit') : t('form.titleCreate')}
                        </h3>

                        <Button
                          variant="secondary"
                          onClick={handleAutoFill}
                          disabled={autoFillLoading}
                          className="d-flex align-items-center gap-2"
                          customStyle={{
                            width: 'fit-content'
                          }}>
                          {autoFillLoading ? (
                            <Spinner size="sm" className="me-2" />
                          ) : (
                            <MdAutoAwesome size={20} className="me-2" />
                          )}
                          {t('form.autoFill')}
                        </Button>
                      </Col>
                      <Col md={12} className={['languageBar', classes.languageBarMain].join(' ')}>
                        <div className={classes.headAndDropDown}>
                          <h4>{t('form.tagline')}</h4>
                          <FormLanguages
                            value={language}
                            setter={setLanguage}
                            className={classes.languagesMain}
                          />
                        </div>
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.projectTitleLabel')}
                          placeholder={t('form.projectTitlePlaceholder')}
                          variant="dashboard"
                          value={formStates?.name?.[language?.value]}
                          setValue={(e) => {
                            let name = e?.slice(0, 20);
                            setFormStates({
                              ...formStates,
                              name: {
                                ...formStates?.name,
                                [language?.value]: name
                              }
                            });
                          }}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.projectTaglineLabel')}
                          placeholder={t('form.projectTaglinePlaceholder')}
                          variant="dashboard"
                          value={formStates?.title?.[language?.value]}
                          setValue={(e) => {
                            let tagline = e?.slice(0, 70);
                            setFormStates({
                              ...formStates,
                              title: {
                                ...formStates?.title,
                                [language?.value]: tagline
                              }
                            });
                          }}
                        />
                      </Col>
                      <Col md={12}>
                        <QuillInput
                          key={`description-${language?.value}`}
                          label={t('form.projectDescriptionLabel')}
                          placeholder={t('form.projectDescriptionPlaceholder')}
                          variant="dashboard"
                          value={formStates?.description?.[language?.value]}
                          setter={(e) =>
                            autoFillLoading
                              ? null
                              : setFormStates({
                                  ...formStates,
                                  description: {
                                    ...formStates?.description,
                                    [language?.value]: e
                                  }
                                })
                          }
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          label={t('form.developerNameLabel')}
                          placeholder={t('form.developerNamePlaceholder')}
                          variant="dashboard"
                          value={formStates?.developerName?.[language?.value]}
                          setValue={(e) =>
                            setFormStates({
                              ...formStates,
                              developerName: {
                                ...formStates?.developerName,
                                [language?.value]: e
                              }
                            })
                          }
                        />
                      </Col>
                      {/* <Col md={6}>
                      <Input
                        label={t('form.registrationNumberLabel')}
                        placeholder={t('form.registrationNumberPlaceholder')}
                        variant="dashboard"
                        value={formStates?.registrationNumber}
                        type={'number'}
                        setValue={(e) =>
                          setFormStates({
                            ...formStates,
                            registrationNumber: e
                          })
                        }
                      />
                    </Col> */}
                      <Col md={6}>
                        <DropDown
                          label={t('form.projectTypeLabel')}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          placeholder={t('form.projectTypePlaceholder')}
                          variant="dashboard"
                          value={formStates?.projectType}
                          options={projectTypes}
                          optionValue={'_id'}
                          getOptionLabel={(e) => e?.title?.[language?.value]}
                          setValue={(e) =>
                            setFormStates({
                              ...formStates,
                              projectType: e
                            })
                          }
                          optionLabel={'title'}
                        />
                      </Col>

                      <Col md={6}>
                        <Input
                          label={t('form.projectPriceLabel')}
                          type={'number'}
                          placeholder={t('form.projectPricePlaceholder')}
                          variant="dashboard"
                          value={formStates?.price}
                          setValue={(e) => {
                            setFormStates({ ...formStates, price: e });
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          label={t('form.projectNoOfUnits')}
                          type={'number'}
                          placeholder={t('form.projectNoOfUnitsPlaceholder')}
                          variant="dashboard"
                          value={formStates?.noOfUnits}
                          setValue={(e) => {
                            setFormStates({ ...formStates, noOfUnits: e });
                          }}
                        />
                      </Col>

                      <Col md={6}>
                        <Input
                          label={t('form.projectMinAreaLabel')}
                          type={'number'}
                          placeholder={t('form.projectMinAreaPlaceholder')}
                          variant="dashboard"
                          value={formStates?.minimumArea}
                          setValue={(e) => {
                            setFormStates({ ...formStates, minimumArea: e });
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <Input
                          label={t('form.projectMaxAreaLabel')}
                          type={'number'}
                          placeholder={t('form.projectMaxAreaPlaceholder')}
                          variant="dashboard"
                          value={formStates?.maximumArea}
                          setValue={(e) => {
                            if (!formStates?.minimumArea)
                              return toast.error(t('form.projectMaxAreaToast'));
                            setFormStates({ ...formStates, maximumArea: e });
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={t('form.projectStatus')}
                          placeholder={t('form.projectStatusPlaceholder')}
                          variant="dashboard"
                          value={formStates?.status}
                          setValue={(e) => {
                            setFormStates({
                              ...formStates,
                              status: e
                            });
                          }}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          optionValue={'_id'}
                          options={projectStatus}
                          getOptionLabel={(e) => {
                            return e?.title?.[language?.value];
                          }}
                        />
                      </Col>

                      {/* <Col md={6}>
                      <Input
                        type={'date'}
                        label={t('form.projectPlanDeliveryDate')}
                        min={moment().format('YYYY-MM-DD')}
                        placeholder={t('form.projectPlanDeliveryDatePlaceholder')}
                        variant="dashboard"
                        value={
                          formStates?.deliveryDate
                            ? moment(formStates?.deliveryDate).format('YYYY-MM-DD')
                            : ''
                        }
                        setValue={(e) =>
                          setFormStates({
                            ...formStates,
                            deliveryDate: e
                          })
                        }
                      />
                    </Col> */}
                      <Col md={6}>
                        <DropDown
                          label={t('form.projectExteriorAmenities')}
                          placeholder={t('form.projectExteriorAmenitiesPlaceholder')}
                          variant="dashboard"
                          value={
                            formStates?.exteriorAmenities?.length > 0
                              ? formStates?.exteriorAmenities
                              : []
                          }
                          setValue={(e) => {
                            setFormStates({
                              ...formStates,
                              exteriorAmenities: e
                            });
                          }}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          optionValue={'_id'}
                          options={exteriorAmenities}
                          isMulti={true}
                          getOptionLabel={(e) => {
                            return e?.title?.[language?.value];
                          }}
                        />
                      </Col>
                      <Col md={6}>
                        <DropDown
                          label={t('form.projectInteriorAmenities')}
                          placeholder={t('form.projectInteriorAmenitiesPlaceholder')}
                          variant="dashboard"
                          value={
                            formStates?.interiorAmenities?.length > 0
                              ? formStates?.interiorAmenities
                              : []
                          }
                          setValue={(e) => {
                            setFormStates({
                              ...formStates,
                              interiorAmenities: e
                            });
                          }}
                          indicatorColor="var(--dashboard-text-gray-clr)"
                          optionValue={'_id'}
                          options={interiorAmenities}
                          isMulti={true}
                          getOptionLabel={(e) => {
                            return e?.title?.[language?.value];
                          }}
                        />
                      </Col>

                      {/* Location */}
                      {/* <Col md={12}>
                    <h4>Location</h4>
                  </Col> */}
                      <Col md={12}>
                        <LocationComponent
                          t={languageD}
                          locationState={locationState}
                          setLocationState={setLocationState}
                          selectedLanguage={language}
                          markerIcon={null}
                        />
                      </Col>

                      {/* media */}
                      <Col md={12}>
                        <h4>{t('form.projectMediaHeading')}</h4>
                      </Col>
                      <Col md={12}>
                        <UploadImageBox
                          setValue={(e) => {
                            if (!['image/png', 'image/jpeg', 'image/jpg'].includes(e?.type))
                              return toast.error(t('toast.error'));
                            setProjectLogo(e);
                          }}
                          value={projectLogo}
                          onDelete={() => setProjectLogo(null)}
                          label={t('form.projectMediaLabel')}
                        />
                      </Col>
                      <Col md={12}>
                        <Divider className={classes.divider} />
                      </Col>
                      {uploadedImages && uploadedImages.length > 0 && (
                        <Col md={12}>
                          <label className={classes.label}>{t('form.projectPlansHeading')}</label>
                          <Row className="gy-3">
                            {uploadedImages?.map((item, index) => (
                              <Col sm={12} md={4} lg={4} xl={3} key={index}>
                                <UploadImageBox
                                  label={''}
                                  value={item}
                                  edit={false}
                                  onDelete={() => {
                                    deleteMedia({
                                      slug,
                                      type: 'images',
                                      key: item,
                                      urlType: 'project'
                                    });
                                  }}
                                />
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      )}

                      <Col md={12}>
                        <FileUpload
                          label={t('form.projectPlansHeading')}
                          files={images}
                          setFiles={(e) => {
                            uploadImagesHelper({
                              images: e,
                              setIsLoading: setIsUploadingImages,
                              setImages: setUploadedImages,
                              token: accessToken
                            });
                          }}
                          text={t('form.dragAndDrop')}
                          orText={t('form.orText')}
                          buttonLabel={t('form.browseFiles')}
                        />
                      </Col>
                      <Col md={12}>
                        <Divider className={classes.divider} />
                      </Col>
                      {uploadedPlanImages && uploadedPlanImages.length > 0 && (
                        <Col md={12}>
                          <label className={classes.label}>{t('form.projectPlansHeading')}</label>
                          <Row className="gy-3">
                            {uploadedPlanImages?.map((item, index) => (
                              <Col md={3} key={index}>
                                <UploadImageBox
                                  value={item}
                                  edit={false}
                                  label={''}
                                  onDelete={() => {
                                    deleteMedia({
                                      slug,
                                      type: 'planImages',
                                      key: item,
                                      urlType: 'project'
                                    });
                                  }}
                                />
                              </Col>
                            ))}
                          </Row>
                        </Col>
                      )}
                      <Col md={12}>
                        <FileUpload
                          label={t('form.projectPlansLabel')}
                          files={planImages}
                          setFiles={(e) => {
                            uploadImagesHelper({
                              images: e,
                              setIsLoading: setIsUploadingImages,
                              setImages: setUploadedPlanImages,
                              token: accessToken
                            });
                          }}
                          text={t('form.dragAndDrop')}
                          orText={t('form.orText')}
                          buttonLabel={t('form.browseFiles')}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.projectVideoLabel')}
                          placeholder={t('form.projectVideoPlaceholder')}
                          variant="dashboard"
                          value={videoLink}
                          setValue={setVideoLink}
                        />
                      </Col>
                      <Col md={12}>
                        <Input
                          label={t('form.project360Link')}
                          placeholder={t('form.project360LinkPlaceholder')}
                          variant="dashboard"
                          value={View360}
                          setValue={(e) => {
                            setView360(e);
                            // setView360DragDrop(null);
                          }}
                        />
                      </Col>
                      {/* <Col className="text-center" md={12}>
                      {t('form.orText')}
                    </Col> */}
                      {/* <Col md={12}>
                      <UploadImageBox
                        label={t('form.project360Upload')}
                        disabled={!!View360}
                        value={view360DragDrop}
                        setValue={(e) => {
                          if (!['image/png', 'image/jpeg', 'image/jpg'].includes(e?.type))
                            return toast.error(t('toast.error'));
                          setView360DragDrop(e);
                          setView360('');
                        }}
                        onDelete={() => {
                          setView360DragDrop(null);
                        }}
                      />
                    </Col> */}
                      <Col md={12}>
                        <CustomFileInput
                          label={t('form.projectPdfCatalogue')}
                          placeholder={''}
                          // placeholder={t('form.projectPdfCataloguePlaceholder')}
                          value={catalogue}
                          isEdit={projectData?.data?.projectBrochureName}
                          setValue={(e) => {
                            if (!['application/pdf'].includes(e?.type))
                              return toast.error(t('toast.pdfOnly'));
                            setCatalogue(e);
                          }}
                          selectedLanguage={language}
                          btnLabel={t('form.projectPdfCatalogueBtn')}
                        />
                      </Col>

                      {/* Project Unit Information */}
                      {/* <Col md={12}>
                    <h4>Project Unit Information</h4>
                  </Col>

                  <Col md={6}>
                    <Input
                      label={'Project Unit Description'}
                      placeholder={'Write Project Unit Description'}
                      variant="dashboard"
                      value={unitDescription}
                      setValue={setUnitDescription}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDown
                      label={'Project Units Type'}
                      placeholder={'Select Project Unit Type'}
                      options={propertyStatusOptions}
                      variant="dashboard"
                      indicatorColor="var(--dashboard-text-gray-clr)"
                      value={unitsType}
                      setValue={setUnitsType}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      type={'number'}
                      label={'Project Units Area*'}
                      placeholder={'Enter Project Units Area'}
                      variant="dashboard"
                      value={unitsArea}
                      setValue={setUnitsArea}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      type={'number'}
                      label={'No. Of Rooms*'}
                      placeholder={'Enter No. Of Rooms'}
                      variant="dashboard"
                      value={rooms}
                      setValue={setRooms}
                      options={NoOfUnitsOptions}
                    />
                  </Col>
                  <Col md={6}>
                    <Input
                      type={'number'}
                      label={'No. Of Bathrooms *'}
                      placeholder={'Enter No. Of Bathrooms'}
                      variant="dashboard"
                      value={bathRooms}
                      setValue={setBathRooms}
                      options={NoOfUnitsOptions}
                    />
                  </Col>

                  <Col md={6}>
                    <Input
                      label={'Car Parking'}
                      placeholder={'Enter Car Parking'}
                      variant="dashboard"
                      value={carParking}
                      setValue={setCarParking}
                    />
                  </Col>
                  <Col md={12}>
                    <FileUpload
                      label={'Project Units Images and Plans'}
                      files={unitImagesAndPlan}
                      setFiles={setUnitImagesAndPlan}
                    />
                  </Col>

                  <Col md={6}>
                    <DropDown
                      label={'Exterior Amenities'}
                      placeholder={'Select Exterior Amenities'}
                      variant="dashboard"
                      value={unitExAmenities}
                      setValue={setUnitExAmenities}
                      indicatorColor="var(--dashboard-text-gray-clr)"
                      options={exteriorAmenitiesOptions}
                      isMulti={true}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDown
                      label={'Interior Amenities'}
                      placeholder={'Select Interior Amenities'}
                      variant="dashboard"
                      value={unitInAmenities}
                      setValue={setUnitInAmenities}
                      indicatorColor="var(--dashboard-text-gray-clr)"
                      options={interiorAmenitiesOptions}
                      isMulti={true}
                    />
                  </Col> */}
                      <Col md={12} className="text-center">
                        <Button
                          label={t(
                            `form.${
                              apiSubmitingLoading
                                ? slug
                                  ? 'updateBtnLoading'
                                  : 'saveBtnLoading'
                                : slug
                                ? 'updateBtn'
                                : 'saveBtn'
                            }`
                          )}
                          disabled={apiSubmitingLoading}
                          onClick={handleSubmit}
                        />
                      </Col>
                    </Row>
                  </Container>
                </div>
              </Col>
            </Row>
          </Container>
        )}

        {(isUploadingImages || isDeletingMedia) && <LottieLoader />}
      </SideBarSkeleton>
    </>
  );
}

export default NewProject;
